import Cookies from 'js-cookie';
import ZhHans from "../../locales/zh-Hans.json";
// import En from "../../locales/en-US.json";

import { handleWindow } from '@/utils';
const win = handleWindow();

// // make sure the js files are in both react-intl/locale-data and intl/locale-data/jsonp/
// const SUPPORTED_LANGS = ['en-US', 'zh-Hans'];

// const pathPrefix = '';

// const checkList = SUPPORTED_LANGS.map(val => val.toLowerCase());

// const getLangInList = (l) => {
//   if (l) {
//     const lowerLang = l.toLowerCase();
//     const [lang] = lowerLang.split('-');
//     if (lang === 'zh' || lang === 'cn') { // cn used for go app
//       // process Chines
//       return 'zh-Hans';
//     } else if (lang === 'en') {
//       // process English
//       return 'en-US';
//     }
//     return checkList[checkList.indexOf(lang)] || null;
//   }
//   return null;
// };
export const getCurrentLang = win.navigator.language;
// export const getCurrentLang = () => {
//   const languages = [
//     getUrlQuery('lang'),
//     // Cookies.get('entertainmentlang'),
//     ...win.navigator.languages || [],
//     win.navigator.language,
//     win.navigator.userLanguage,
//     'en-US',
//   ];

//   for (let i = 0; i < languages.length; i += 1) {
//     const lang = getLangInList(languages[i]);
//     if (lang) {
//       return lang;
//     }
//   }
//   return 'en-US';
// };

// const setLangCookie = (lang) => {
//   Cookies.set('entertainmentlang', lang === 'zh-Hans' ? 'zh-CN' : lang, { expires: 7, path: '/' }); // should remove after old skypixel.com offline completely
// };

// export const currentLang = getCurrentLang();
// setLangCookie(currentLang);

// export const changeLang = (lang) => {
//   if (lang === currentLang) {
//     return;
//   }
//   setLangCookie(lang);
//   win.location.reload();
// };

export const isChinese =  Cookies.get('server-location') === 'cn';

// const addLocale = () => (
//   Promise.all([
//     import(`../locales/${currentLang}`),
//     import(`../../locales/${pathPrefix}${currentLang}.json`),
//   ]).then(([cur, messages]) => {
//     addLocaleData([...cur.default]);
//     return messages;
//   }).then(messages => ({ locale: currentLang, messages }))
// );

// const ensure = () => {
//   if (!win.Intl) {
//     return import('intl')
//       .then(() => (
//         Promise.all([
//           import(`../locales/intl-${currentLang}`),
//           import(`../../locales/${pathPrefix}${currentLang}.json`),
//         ])
//       )).then(() => addLocale());
//   }
//   return addLocale();
// };
// export default ensure;

const i18nData = {
  locale: 'en',
  messages: ZhHans,
};

export default i18nData;
